<template>
  <div class="pr-3">
       <span data-v-1f36f992="" class="title p-2">{{ label }}</span>
  </div>

</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "competencia-nav",
    computed:{
      ...mapState(['competenciaOpen']),
      label()
      {
        return this.competenciaOpen ? this.competenciaOpen.label : 'S/C'
      }
    }
  }
</script>
<style scoped>
  .title {
     font-size: 1.2em;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/features/Competencia/CompetenciaNav.vue